<!-- 
Dialog for changing the due date of an invoice.

This is a testing tool only, which won't be available in production.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Change invoice due date</v-toolbar-title>
        </v-toolbar>
        <v-alert :value="true" type="info" class="ma-0">
          This is a testing tool only. It will not be available in the production environment.
        </v-alert>
        <our-busy-indicator :show="busy"/>
        <v-card-text>
          <our-date-picker
            :value="data.due"
            label="Due*"
            required
            autofocus
            @input="update('due', $event)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="busy" flat @click="hide">Cancel</v-btn>
          <v-btn :disabled="busy" flat color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error"/>
  </v-dialog>
</template>

<script>
import * as action from "@/store/invoices/action-types";
import * as mutation from "@/store/invoices/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoiceId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      showValidationDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.invoices.due;
    },
    busy() {
      return this.state.loading || this.state.saving;
    },
    data() {
      return this.state.data;
    }
  },
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        this.$store.dispatch(action.DUE_GET, this.invoiceId);
      }
    }
  },
  methods: {
    update(field, newValue) {
      this.$store.commit(mutation.DUE_SET_DATA, { [field]: newValue });
    },
    async save() {
      if (this.$refs.form.validate() && (await this.$store.dispatch(action.DUE_SAVE, this.invoiceId))) {
        this.hide();
      } else {
        this.showValidationDialog = true;
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
